export const CONFIG = {
  GEMINI_API_KEY: "AIzaSyBXJLWVnnsFJwp5bGGG_1L8OieMUXFBQ9g",
  GEMINI_API_URL: "https://generativelanguage.googleapis.com/v1/models/gemini-2.5-flash:generateContent"
};

export const getScoreColor = (score) => {
  if (score >= 8) return 'text-green-600';
  if (score >= 6) return 'text-yellow-600';
  return 'text-red-600';
}